type RGBColor = {
  r: number;
  g: number;
  b: number;
};

function hexToRgb(hex: string): RGBColor | null {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }
    : null;
}

export function hexToRgbString(hex: string): string | null {
  const rgbColor = hexToRgb(hex);
  return rgbColor ? `rgb(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b})` : null;
}

export default hexToRgb;
